// -----------------------------------------------------------------------------
// TurnMachine — macchina a stati del TURNO di gioco (Fase 4).
// Puro, senza dipendenze da React/DOM: così è testabile in isolamento.
// NON contiene la logica delle prove/verifica (quella resta nel motore golden
// master, invariato): qui si gestiscono solo tempo, conteggio tocchi e stato.
//
// Regole critiche richieste:
//  - il tocco vale al MOMENTO DEL CONTATTO (pointerdown), non al rilascio;
//  - un tocco INIZIATO prima della scadenza è valido anche se elaborato subito
//    dopo (finché il turno non è stato risolto): confronto sul timestamp di inizio;
//  - dopo la risoluzione (RESULT) nessun nuovo tocco viene accettato;
//  - un singolo pointerdown = esattamente +1 (nessun doppio conteggio qui).
// -----------------------------------------------------------------------------

export const Phase = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  RESULT: "RESULT",
};

export function createTurn(durationMs, startTime) {
  return {
    duration: durationMs,
    startTime,
    expiryTime: startTime + durationMs,
    phase: Phase.ACTIVE,
    taps: 0,
    frozenTaps: null,
    resolved: false,
  };
}

// Registra un tocco iniziato a `tapStartTime` (stessa base temporale di startTime).
// Ritorna true se conteggiato.
export function registerTap(turn, tapStartTime) {
  if (turn.resolved || turn.phase === Phase.RESULT) return false; // dopo RESULT: stop
  if (tapStartTime > turn.expiryTime) return false; // iniziato dopo la scadenza: no
  turn.taps += 1; // un contatto = +1
  return true;
}

// Timer arrivato a 0: ACTIVE -> EXPIRED. Durante EXPIRED si accettano ancora
// tocchi iniziati entro la scadenza (grazie al confronto sul timestamp), finché
// non si chiama resolve().
export function expire(turn) {
  if (turn.phase === Phase.ACTIVE) turn.phase = Phase.EXPIRED;
  return turn;
}

// Congela il conteggio e passa a RESULT. Dopo questo, registerTap rifiuta tutto.
// Ritorna il conteggio definitivo (da confrontare con il motore via isCorrect).
export function resolve(turn) {
  if (turn.phase !== Phase.RESULT) {
    if (turn.phase === Phase.ACTIVE) turn.phase = Phase.EXPIRED;
    turn.frozenTaps = turn.taps;
    turn.phase = Phase.RESULT;
    turn.resolved = true;
  }
  return turn.frozenTaps;
}

// Progresso 1 -> 0 in base al tempo corrente (per il timer visivo).
export function progressAt(turn, now) {
  const remaining = turn.expiryTime - now;
  if (remaining <= 0) return 0;
  if (remaining >= turn.duration) return 1;
  return remaining / turn.duration;
}
